<template>
  <div v-loading="loading">
    <el-table
      :data="users"
      border
    >
      <el-table-column
        label="Képviselő"
        prop="full_name"
      >
        <template slot-scope="scope">
          <div style="display: inline-block;">
            <div style="display: inline-block;" v-if="scope.row.rank === 1">
              <i class="el-icon-star-on" style="color: #ecbf19;margin-right: 5px;"></i>
            </div>
            <div style="display: inline-block;" v-if="scope.row.rank === 2">
              <i class="el-icon-star-on" style="color: #a9a9a9;margin-right: 5px;"></i>
            </div>
            <div style="display: inline-block;" v-if="scope.row.rank === 3">
              <i class="el-icon-star-on" style="color: #d08c11;margin-right: 5px;"></i>
            </div>
            <div style="display: inline-block;">
              {{ scope.row.full_name }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Nettó"
        prop="net_sum"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.net_sum | currency }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      itemLoading: 0,
      currentSort: {
        prop: 'gross_price',
        order: 'desc',
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters['outstanding/outstandingsByUsers'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['outstanding/tableConfig']));
    },
    loading() {
      return this.$store.getters['outstanding/userLoading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    await this.$store.dispatch('outstanding/fetchByUsers');
  },
  methods: {
    getSum(params) {
      let result = [];
      let netSum = 0;
      let grossSum = 0;
      params.data.forEach(outstanding => {
        netSum += outstanding.net_price;
        grossSum += outstanding.gross_price;
      });
      result = params.columns.map((column, index) => {
        if (index === 0) {
          return 'Össz.:';
        }
        if (column.property === 'net_price') {
          return this.$options.filters.currency(netSum.toFixed(2));
        }
        if (column.property === 'gross_price') {
          return this.$options.filters.currency(grossSum.toFixed(2));
        }
        return '';
      });
      return result;
    },
  },
};
</script>
<style lang="scss">
  .outstanding-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
